import type { Session } from '@supabase/auth-js';
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { auth } from './supabase';

interface SessionState {
  session: Session | null;
  loading: boolean;
}

const SessionContext = createContext<SessionState>({ session: null, loading: true });

export function SessionProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<SessionState>({ session: null, loading: Boolean(auth) });

  useEffect(() => {
    if (!auth) return;
    auth.getSession().then(({ data }) => setState({ session: data.session, loading: false }));
    const { data } = auth.onAuthStateChange((_event, session) =>
      setState({ session, loading: false }),
    );
    return () => data.subscription.unsubscribe();
  }, []);

  return <SessionContext.Provider value={state}>{children}</SessionContext.Provider>;
}

export function useSession(): SessionState {
  return useContext(SessionContext);
}

export async function signOut(): Promise<void> {
  try {
    localStorage.removeItem('supabase.auth.token');
  } catch {
    // armazenamento indisponível
  }
  await auth?.signOut({ scope: 'local' });
  window.location.assign('/entrar');
}
